import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { Filters } from './types';

const DEFAULT_FILTERS: Filters = {
  page: 1,
  items: 50,
};

const parseFunctions: TParseFunctions<Filters> = {
  page: parseSearchNumberValue,
  phone: parseSearchStringValue,
  callId: parseSearchStringValue,
  agent: parseSearchStringValue,
  patientGuid: parseSearchStringValue,
};

export const useCallHistoryManagementFilters = () => {
  return useQueryFilterNew<Filters>(DEFAULT_FILTERS, parseFunctions, [
    'page',
    'items',
  ]);
};
